import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { Col, Row, Button, Popover } from "antd";
import { withRouter } from "react-router-dom";
import "./MultiSelectorHeaderOptions.css";
import MultiDownloadModal from "./MultiDownloadModal";
import MultiShareModal from "./MultiShareModal";
import MultiDeleteModal from "./MultiDeleteModal";
import MultiMoveModal from "./MultiMoveModal";
import MultiBunkeyHostModal from "./MultiBunkeyHostModal";
import { cancelSelect, addAll } from "../../actions/MultiselectAction";
import {
  multiAddFavoriteAsset,
  multiRemoveFavoriteAsset
} from "../../actions/AssetsFavoritesAction";
import menuVertical from "../../assets/menu-vertical.svg";
import CloseIcon from "../../assets/close-icon.svg";
import { getBreadCrumbs, getNewPermission, canDeleteAsset } from "../../utils";

class MultiSelectorHeaderOptions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      canMove: true,
      canShare: true,
      canAddToFavorites: true,
      canDownload: true,
      showModalMultiDownload: false,
      showModalMultiShare: false,
      showModalMultiDelete: false,
      showModalMultiMove: false,
      showModalMultiBunkeyHost: false,
      visibleOptions: false
    };
  }

  /**
   * ¿Puede borrarse TODA la selección?
   *
   * Antes esto era `canDelete: true` fijo en el state y nunca se recalculaba:
   * el botón de eliminar de la barra de multi-selección se le mostraba a
   * cualquiera, sin importar los permisos de su grupo. Se resuelve por asset y
   * con el permiso que corresponde a su tipo (`deleteFolder` para carpetas),
   * con el mismo criterio de canBunkeyHost: si el permiso individual lo niega,
   * la acción bulk no se ofrece.
   */
  canDelete() {
    const { newMatrix, user, selectedFiles } = this.props;

    if (!selectedFiles || !selectedFiles.length) return false;

    const isAdmin =
      !!user && (user.clientRole === "admin" || user.role === "admin");
    if (isAdmin) return true;

    return selectedFiles.every(asset => canDeleteAsset(asset, newMatrix));
  }

  // Mismo criterio que la vista de un asset (CollectionMiddleView), para que la
  // acción bulk no ofrezca algo que el permiso individual niega.
  canBunkeyHost() {
    const { modules, newMatrix, user, selectedFiles } = this.props;

    if (!selectedFiles || !selectedFiles.length) return false;

    const isAdmin =
      !!user && (user.clientRole === "admin" || user.role === "admin");

    const module = (modules || []).find(m => m.name === "BunkeyHost");
    if (!isAdmin && !(module && module.activate)) return false;
    if (isAdmin) return true;

    return selectedFiles.every(asset =>
      getNewPermission(asset._id, newMatrix, "bunkeyHost")
    );
  }

  handleShowModalMultiBunkeyHost = () => {
    this.setState({
      showModalMultiBunkeyHost: true,
      visibleOptions: false
    });
  };

  handleHiddenModalMultiBunkeyHost = () => {
    this.setState({
      showModalMultiBunkeyHost: false
    });
  };

  handleShowModalMultiDownload = () => {
    this.setState({
      showModalMultiDownload: true,
      visibleOptions: false
    });
  };

  handleHiddenModalMultiDownload = () => {
    this.setState({
      showModalMultiDownload: false
    });
  };

  handleShowModalMultiShare = () => {
    this.setState({
      showModalMultiShare: true,
      visibleOptions: false
    });
  };

  handleHiddenModalMultiShare = () => {
    this.setState({
      showModalMultiShare: false
    });
  };

  handleShowModalMultiDelete = () => {
    this.setState({
      showModalMultiDelete: true,
      visibleOptions: false
    });
  };

  handleHiddenModalMultiDelete = () => {
    this.setState({
      showModalMultiDelete: false
    });
  };

  handleShowModalMultiMove = () => {
    this.setState({
      showModalMultiMove: true,
      visibleOptions: false
    });
  };

  handleHiddenModalMultiMove = () => {
    this.setState({
      showModalMultiMove: false
    });
  };

  handleChangeVisibleOptions = value => {
    this.setState({
      visibleOptions: value
    });
  };

  allFavorite(array) {
    for (let i = 0; i < array.length; i++) {
      if (!array[i].isFavorite) {
        return false;
      }
    }
    return true;
  }

  handleAddFavorites = () => {
    const {
      selectedFiles,
      favoriteAssets,
      multiAddFavoriteAsset,
      multiRemoveFavoriteAsset,
      workclient,
      workspace,
      intl
    } = this.props;
    const favoritesIds = favoriteAssets.map(e => e._id);
    const filesToUpdate = selectedFiles.map(e => {
      const isFavorite = favoritesIds.includes(e._id);
      return {
        ...e,
        isFavorite: isFavorite
      };
    });
    const isAllFavorite = this.allFavorite(filesToUpdate);

    if (isAllFavorite) {
      multiRemoveFavoriteAsset(workclient, workspace, filesToUpdate, intl);
    } else {
      multiAddFavoriteAsset(workclient, workspace, filesToUpdate, intl);
    }
  };

  componentDidUpdate(prevProps) {
    const { isFetching, isMoving, error, sended } = this.props;
    const {
      isFetching: isFetchingOld,
      isMoving: isMovingOld,
      sended: sendedOld
    } = prevProps;
    if (isFetchingOld && !isFetching && !error) {
      if (this.state.showModalMultiDelete) {
        this.props.cancelSelect();
        this.handleHiddenModalMultiDelete();
      }
    }
    if (isMovingOld && !isMoving && !error) {
      if (this.state.showModalMultiMove) {
        this.props.cancelSelect();
        this.handleHiddenModalMultiMove();
      }
    }
    if (!sendedOld && sended) {
      this.props.cancelSelect();
      this.handleHiddenModalMultiShare();
    }
  }

  render() {
    const {
      selectedFiles,
      intl,
      cancelSelect,
      addAll,
      currentFiles,
      keyCollection,
      isFetching,
      isMoving,
      folderselect,
      newColor
    } = this.props;
    const {
      canMove,
      canShare,
      canAddToFavorites,
      canDownload,
      showModalMultiDownload,
      showModalMultiShare,
      showModalMultiDelete,
      showModalMultiMove,
      showModalMultiBunkeyHost,
      visibleOptions
    } = this.state;

    const breadcrumbState = getBreadCrumbs(folderselect);
    const folderName = [...breadcrumbState].pop();

    return (
      <>
        {selectedFiles && selectedFiles.length > 0 && (
          <div className="multiselector-container" style={{ width: "100%" }}>
            <div className={"container"}>
              <Row
                type={"flex"}
                justify={"space-between"}
                align={"middle"}
                style={{ height: "100%" }}
              >
                <Col span={22}>
                  <span
                    style={{
                      marginRight: 17,
                      color: newColor,
                      fontSize: 15,
                      fontWeight: 600
                    }}
                  >
                    <img
                      src={CloseIcon}
                      alt="icon file void"
                      style={{
                        marginRight: 10,
                        width: 20,
                        height: 20,
                        cursor: "pointer"
                      }}
                      onClick={cancelSelect}
                    />
                    {intl.formatMessage({ id: "multi-share-selected" })}{" "}
                    {selectedFiles ? selectedFiles.length : 0}{" "}
                    {`${
                      selectedFiles && selectedFiles.length === 1
                        ? intl.formatMessage({
                            id: "multi-share-selected-item"
                          })
                        : intl.formatMessage({
                            id: "multi-share-selected-items"
                          })
                    }`}
                  </span>
                  <Button
                    shape={"round"}
                    type={"primary"}
                    size={"small"}
                    style={{
                      marginRight: 17,
                      backgroundColor: newColor,
                      borderColor: newColor
                    }}
                    onClick={() => {
                      cancelSelect();
                    }}
                  >
                    {intl.formatMessage({ id: "cancel_button" })}
                  </Button>
                  <Button
                    shape={"round"}
                    type={"primary"}
                    size={"small"}
                    style={{ backgroundColor: newColor, borderColor: newColor }}
                    onClick={() => {
                      addAll(currentFiles, keyCollection);
                    }}
                  >
                    {intl.formatMessage({ id: "select_all" })}
                  </Button>
                </Col>
                {/* <Col xs={4} sm={4} md={8}> */}
                <Col span={2}>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "end"
                    }}
                  >
                    <Popover
                      onVisibleChange={this.handleChangeVisibleOptions}
                      id={"menu-options-multi-selector"}
                      placement={"bottomRight"}
                      visible={visibleOptions}
                      content={
                        <ul>
                          {canDownload && (
                            <li onClick={this.handleShowModalMultiDownload}>
                              <svg
                                viewBox="64 64 896 896"
                                focusable="false"
                                data-icon="cloud-download"
                                width="1em"
                                height="1em"
                                fill="currentColor"
                                aria-hidden="true"
                              >
                                <path d="M624 706.3h-74.1V464c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v242.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.7a8 8 0 0 0 12.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9z" />
                                <path d="M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7a123.07 123.07 0 0 1-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z" />
                              </svg>{" "}
                              <span style={{ marginLeft: 5 }}>
                                {intl.formatMessage({ id: "downloads" })}
                              </span>
                            </li>
                          )}
                          {this.canDelete() && (
                            <li onClick={this.handleShowModalMultiDelete}>
                              <svg
                                width="12"
                                height="13"
                                viewBox="0 0 12 13"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M1 3.20009H2.11111M2.11111 3.20009H11M2.11111 3.20009L2.11116 10.9C2.11116 11.1917 2.22822 11.4715 2.43659 11.6778C2.64497 11.8841 2.92758 12 3.22227 12H8.77782C9.07251 12 9.35512 11.8841 9.5635 11.6778C9.77187 11.4715 9.88893 11.1917 9.88893 10.9V3.2L2.11111 3.20009ZM3.77782 3.2V2.1C3.77782 1.80826 3.89489 1.52847 4.10326 1.32218C4.31163 1.11589 4.59425 1 4.88893 1H7.11116C7.40584 1 7.68846 1.11589 7.89683 1.32218C8.1052 1.52847 8.22227 1.80826 8.22227 2.1V3.2M7.11103 5.95004V9.25045M4.8888 5.95004V9.25045"
                                  stroke="#28293D"
                                />
                              </svg>{" "}
                              <span style={{ marginLeft: 5 }}>
                                {intl.formatMessage({ id: "delete_asset" })}
                              </span>
                            </li>
                          )}
                          {canShare && (
                            <li onClick={this.handleShowModalMultiShare}>
                              <svg
                                width="13"
                                height="13"
                                viewBox="0 0 13 13"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M9.75019 11.9169C10.6478 11.9169 11.3754 11.1893 11.3754 10.2917C11.3754 9.39413 10.6478 8.6665 9.75019 8.6665C8.85262 8.6665 8.125 9.39413 8.125 10.2917C8.125 11.1893 8.85262 11.9169 9.75019 11.9169Z"
                                  stroke="#28293D"
                                />
                                <path
                                  d="M3.25019 8.12525C4.14775 8.12525 4.87538 7.39763 4.87538 6.50007C4.87538 5.6025 4.14775 4.87488 3.25019 4.87488C2.35262 4.87488 1.625 5.6025 1.625 6.50007C1.625 7.39763 2.35262 8.12525 3.25019 8.12525Z"
                                  stroke="#28293D"
                                />
                                <path
                                  d="M4.65234 7.31775L8.35235 9.47383"
                                  stroke="#28293D"
                                />
                                <path
                                  d="M9.75019 4.33351C10.6478 4.33351 11.3754 3.60588 11.3754 2.70832C11.3754 1.81075 10.6478 1.08313 9.75019 1.08313C8.85262 1.08313 8.125 1.81075 8.125 2.70832C8.125 3.60588 8.85262 4.33351 9.75019 4.33351Z"
                                  stroke="#28293D"
                                />
                                <path
                                  d="M8.34791 3.52612L4.65332 5.68221"
                                  stroke="#28293D"
                                />
                              </svg>{" "}
                              <span style={{ marginLeft: 5 }}>
                                {intl.formatMessage({ id: "shared_share" })}
                              </span>
                            </li>
                          )}
                          {this.canBunkeyHost() && (
                            <li onClick={this.handleShowModalMultiBunkeyHost}>
                              <svg
                                width="13"
                                height="13"
                                viewBox="0 0 13 13"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5.42 7.58a2.17 2.17 0 003.27.23l1.3-1.3a2.17 2.17 0 00-3.07-3.06l-.74.74"
                                  stroke="#28293D"
                                />
                                <path
                                  d="M7.58 5.42a2.17 2.17 0 00-3.27-.23l-1.3 1.3a2.17 2.17 0 003.07 3.06l.74-.74"
                                  stroke="#28293D"
                                />
                              </svg>{" "}
                              <span style={{ marginLeft: 5 }}>
                                {intl.formatMessage({
                                  id: "insert_gallery_bunkey_host"
                                })}
                              </span>
                            </li>
                          )}
                          {canAddToFavorites && (
                            <li onClick={this.handleAddFavorites}>
                              <svg
                                width="13"
                                height="12"
                                viewBox="0 0 13 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M11.2897 1.49733C11.013 1.22051 10.6845 1.00091 10.3229 0.851085C9.96129 0.70126 9.57373 0.624146 9.18233 0.624146C8.79093 0.624146 8.40337 0.70126 8.04178 0.851085C7.68019 1.00091 7.35167 1.22051 7.07497 1.49733L6.50073 2.07158L5.92649 1.49733C5.36758 0.938426 4.60954 0.624435 3.81913 0.624435C3.02871 0.624435 2.27067 0.938426 1.71176 1.49733C1.15286 2.05624 0.838867 2.81428 0.838867 3.60469C0.838867 4.39511 1.15286 5.15315 1.71176 5.71205L2.28601 6.2863L6.50073 10.501L10.7155 6.2863L11.2897 5.71205C11.5665 5.43536 11.7861 5.10683 11.9359 4.74524C12.0858 4.38366 12.1629 3.99609 12.1629 3.60469C12.1629 3.21329 12.0858 2.82573 11.9359 2.46414C11.7861 2.10255 11.5665 1.77403 11.2897 1.49733V1.49733Z"
                                  stroke="#28293D"
                                />
                                <path
                                  d="M6.59277 3.53247V6.78327"
                                  stroke="#28293D"
                                />
                                <path
                                  d="M4.96777 5.15759H8.21858"
                                  stroke="#28293D"
                                />
                              </svg>{" "}
                              <span style={{ marginLeft: 5 }}>
                                {intl.formatMessage({ id: "add_to_favorites" })}
                              </span>
                            </li>
                          )}
                          {canMove && (
                            <li onClick={this.handleShowModalMultiMove}>
                              <svg
                                width="11"
                                height="11"
                                viewBox="0 0 11 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M1.65001 1.09999C1.50414 1.09999 1.36424 1.15794 1.26109 1.26108C1.15795 1.36423 1.1 1.50412 1.1 1.65V9.35C1.1 9.49587 1.15795 9.63577 1.26109 9.73892C1.36424 9.84206 1.50414 9.90001 1.65001 9.90001H3.85003C4.15379 9.90001 4.40003 10.1463 4.40003 10.45C4.40003 10.7538 4.15379 11 3.85003 11H1.65001C1.2124 11 0.792714 10.8262 0.483277 10.5167C0.17384 10.2073 0 9.78761 0 9.35V1.65C0 1.21239 0.17384 0.792707 0.483277 0.483273C0.792714 0.173838 1.2124 0 1.65001 0H3.85003C4.15379 0 4.40003 0.246241 4.40003 0.549995C4.40003 0.853748 4.15379 1.09999 3.85003 1.09999H1.65001ZM7.31104 2.36102C7.52583 2.14623 7.87407 2.14623 8.08886 2.36102L10.8389 5.11105C11.0537 5.32583 11.0537 5.67407 10.8389 5.88886L8.08886 8.63889C7.87407 8.85367 7.52583 8.85367 7.31104 8.63889C7.09625 8.4241 7.09625 8.07586 7.31104 7.86108L9.1222 6.04993L3.84999 6.04987C3.54624 6.04987 3.3 5.80362 3.3 5.49987C3.3 5.19611 3.54625 4.94988 3.85001 4.94988L9.12217 4.94994L7.31104 3.13883C7.09625 2.92404 7.09625 2.5758 7.31104 2.36102Z"
                                  fill="#28293D"
                                />
                              </svg>{" "}
                              <span style={{ marginLeft: 5 }}>
                                {intl.formatMessage({ id: "move_asset" })}
                              </span>
                            </li>
                          )}
                        </ul>
                      }
                    >
                      <img
                        src={menuVertical}
                        alt="menu"
                        style={{
                          width: "20px",
                          height: "20px",
                          borderRadius: 50
                        }}
                      />
                    </Popover>
                  </div>
                </Col>
              </Row>
            </div>

            {showModalMultiDownload && (
              <MultiDownloadModal
                showModal={showModalMultiDownload}
                handleHiddenModal={this.handleHiddenModalMultiDownload}
                keyCollection={keyCollection}
              />
            )}

            {showModalMultiShare && (
              <MultiShareModal
                showModal={showModalMultiShare}
                handleHiddenModal={this.handleHiddenModalMultiShare}
                keyCollection={keyCollection}
                selectedFiles={selectedFiles}
              />
            )}

            {showModalMultiDelete && (
              <MultiDeleteModal
                showModal={showModalMultiDelete}
                handleHiddenModal={this.handleHiddenModalMultiDelete}
                keyCollection={keyCollection}
                isFetching={isFetching}
                folderName={folderName ? folderName.name : ""}
              />
            )}

            {showModalMultiMove && (
              <MultiMoveModal
                showModal={showModalMultiMove}
                handleHiddenModal={this.handleHiddenModalMultiMove}
                keyCollection={keyCollection}
                isMoving={isMoving}
              />
            )}

            {showModalMultiBunkeyHost && (
              <MultiBunkeyHostModal
                showModal={showModalMultiBunkeyHost}
                handleHiddenModal={this.handleHiddenModalMultiBunkeyHost}
              />
            )}
          </div>
        )}
        {selectedFiles && selectedFiles.length > 0 && (
          <div
            style={{
              width: "100%",
              height: 100
            }}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = state => {
  const { keyCollection } = state.selectedFiles;

  let object;

  switch (keyCollection) {
    case "assetsRoot":
      object = {
        isFetching: state.assetsRoot.isFetching,
        isMoving: state.assetsRoot.isMoving,
        error: state.assetsRoot.error,
        currentFiles: state.assetsRoot.data,
        folderselect: state.assetsRoot.folderselect
      };
      break;
    case "assetsLastUploads":
      object = {
        isFetching: state.assetsLastUploads.isFetching,
        isMoving: state.assetsLastUploads.isMoving,
        error: state.assetsLastUploads.error,
        currentFiles: state.assetsLastUploads.data,
        folderselect: state.assetsLastUploads.folderselect
      };
      break;
    case "assetsShared":
      object = {
        isFetching: state.assetsShared.isFetching,
        isMoving: state.assetsShared.isMoving,
        error: state.assetsShared.error,
        currentFiles: state.assetsShared.data,
        folderselect: state.assetsShared.folderselect
      };
      break;
    case "assetsFavorites":
      object = {
        isFetching: state.assetsFavorites.isFetching,
        isMoving: state.assetsFavorites.isMoving,
        error: state.assetsFavorites.error,
        currentFiles: state.assetsFavorites.data,
        folderselect: state.assetsFavorites.folderselect
      };
      break;
    case "assetsExplore":
      object = {
        isFetching: state.assetsExplore.isFetching,
        isMoving: state.assetsExplore.isMoving,
        error: state.assetsExplore.error,
        currentFiles: state.assetsExplore.data,
        folderselect: state.assetsExplore.folderselect
      };
      break;
    case "searcher":
      object = {
        isFetching: state.searcher.isFetching,
        isMoving: state.searcher.isMoving,
        error: state.searcher.error,
        currentFiles: state.searcher.data,
        folderselect: state.searcher.folderselect
      };
      break;

    default:
      object = {};
      break;
  }
  return {
    ...object,
    workclient: state.client.workclient,
    selectedFiles: state.selectedFiles.data,
    keyCollection: state.selectedFiles.keyCollection,
    modules: state.client.data ? state.client.data.modules : [],
    newMatrix: state.group.newMatrix,
    user: state.authUser.user,
    favoriteAssets: state.assetsFavorites.data,
    workspace: state.assetsFavorites.workspace,
    sended: state.assetsShared.sended,
    newColor:
      state.authUser.user && state.authUser.user.color
        ? state.authUser.user.color
        : "#2E97CF"
  };
};

const mapDispatchToProps = {
  cancelSelect,
  addAll,
  multiAddFavoriteAsset,
  multiRemoveFavoriteAsset
};

export default injectIntl(
  withRouter(
    connect(mapStateToProps, mapDispatchToProps)(MultiSelectorHeaderOptions)
  )
);
